import React from 'react'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from '@material-ui/core'
import { ParametreItem } from './ParametreItem'
import { useFieldArray } from 'react-hook-form'
import { AddParam } from './AddParam'

export const ParametreListe = ({ useFormObj }) => {
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    control: useFormObj.control, // control props comes from useForm (optional: if you are using FormProvider)
    name: 'paramList', // unique name for your Field Array
  })

  return (
    <Paper square sx={{ m: 3 }}>
      <Toolbar
        sx={[
          {
            pl: { sm: 2 },
            pr: { xs: 1, sm: 1 },
          },
        ]}
      >
        <Typography sx={{ flex: '1 1 100%' }} variant="h6" id="tableTitle" component="div">
          Paramètres:
        </Typography>
        <AddParam addParamHandler={append} existingParam={fields} />
      </Toolbar>
      {!!fields.length && (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Nom</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Oligatoire</TableCell>
                <TableCell>Origines</TableCell>
                <TableCell>Origine par defaut</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {fields.map((field, index) => (
                <ParametreItem
                  key={field.id}
                  field={field}
                  index={index}
                  deleteLigne={remove}
                  useFormObj={useFormObj}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  )
}
